import ContactActionsController from "./contact_actions_controller"

// The detail menu stays attached to its card/header, including after the
// sidebar hoists it. Fit the expanded list above or below that local trigger.
export default class extends ContactActionsController {
    connect() {
        super.connect()
        this._fit = () => this._fitMenu()
        this._menuObserver = new MutationObserver(this._fit)
        this._menuObserver.observe(this.element.querySelector(".contact-menu-panel"), { attributes: true, attributeFilter: ["class"] })
        window.addEventListener("resize", this._fit)
    }

    disconnect() {
        super.disconnect()
        this._menuObserver?.disconnect()
        window.removeEventListener("resize", this._fit)
    }

    _fitMenu() {
        const menu = this.element.querySelector(".contact-menu-panel")
        if (!menu?.classList.contains("is-open")) return
        const trigger = this.element.querySelector(".contact-detail-menu-btn").getBoundingClientRect()
        const below = window.innerHeight - trigger.bottom - 14
        const above = trigger.top - 14
        const flip = below < Math.min(menu.scrollHeight, 200) && above > below
        menu.style.position = "fixed"
        menu.style.right = "auto"
        menu.style.bottom = "auto"
        menu.style.maxHeight = `${Math.max(96, flip ? above : below)}px`
        menu.style.left = `${Math.max(8, Math.min(trigger.right - menu.offsetWidth, window.innerWidth - menu.offsetWidth - 8))}px`
        menu.style.top = `${flip ? Math.max(8, trigger.top - menu.offsetHeight - 6) : trigger.bottom + 6}px`
    }
}
